export default __webpack_public_path__ + "b19e7cfc78822243ed930458ed5c3cda.png";